import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizerPipe } from 'tangoe-design-system';

@Component({
  selector: 'ts-view-details',
  templateUrl: './view-details.component.html',
  imports: [CommonModule, DomSanitizerPipe]
})
export class ViewDetailsComponent {
  @Input() modal_title: string;
  @Input() modal_body: string;
  @Input() limit_modal_title: boolean = true;
  @Input() normalize_external_styles: boolean = false;

  constructor(private activeModal: NgbActiveModal) {}

  dismissModal(): void {
    this.activeModal.dismiss();
  }
}
